import React from 'react';
import { TypedMap } from 'flow/types/TypedMap';

import DashboardSettingsList from 'flow/components/dashboard/DashboardSettingsList';

interface Settings {
    dataPeriodType: 'daily' | 'custom';
    dataPeriod: number;
    serviceLevelPeriod?: number;
    serviceLevelWarningThreshold?: number;
}

interface Props {
    wallboardSettings: TypedMap<Settings>;
    onNavigateToCustomizeSettings: () => void;
    onNavigateToVisibilitySettings: () => void;
    boardType: 'hunt_groups_multiple' | 'team_custom';
}

const DashboardSettings = ({
    wallboardSettings,
    onNavigateToCustomizeSettings,
    onNavigateToVisibilitySettings,
    boardType,
}: Props) => {
    const dataPeriodHours = wallboardSettings.get('dataPeriod') / 3600;
    const dataPeriodType = wallboardSettings.get('dataPeriodType');
    const serviceLevelPeriod = wallboardSettings.get('serviceLevelPeriod');
    const serviceLevelWarningThreshold = wallboardSettings.get(
        'serviceLevelWarningThreshold',
    );

    return (
        <DashboardSettingsList
            dataPeriodHours={dataPeriodHours}
            dataPeriodType={dataPeriodType}
            serviceLevelPeriod={serviceLevelPeriod}
            serviceLevelWarningThreshold={serviceLevelWarningThreshold}
            onNavigateToCustomizeSettings={onNavigateToCustomizeSettings}
            onNavigateToVisibilitySettings={onNavigateToVisibilitySettings}
            boardType={boardType}
        />
    );
};

export default DashboardSettings;
